/**
 * Labstep
 */

import { MediaQueryDesktop as Desktop } from 'labstep-web/core/MediaQuery/Desktop';
import type React from 'react';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { IModalWizardStepHelpProps } from './types';

export const ModalWizardStepHelp: React.FC<
  IModalWizardStepHelpProps
> = ({ help }) => (
  <Desktop>
    {({ match }) =>
      match ? (
        <div className={styles.help}>
          <div className={styles.helpContent}>
            {help}
            <Image
              className={styles.image}
              src="/img/help/steppy.svg"
            />
          </div>
        </div>
      ) : null
    }
  </Desktop>
);
